//Model
PJQ.models.settings.Region = PJQ.models.BaseModel.extend({
    idAttribute: 'regionId',
    notifyName: 'Region',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'regions',
                value: this.id
            }
        ])
    }
});
//Collection
PJQ.collections.settings.Regions = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.settings.Region,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'regions'
            }
        ])
    }
});

PJQ.views.settings.RegionSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Regions')
    },
    events: {
        'click .add-region': 'addClicked',
        'click .btn-edit-region': 'editRegion',
        'click .btn-delete-region': 'deleteRegion',
        'click .btn-save-region': 'regionSave',
        'click .btn-cancel-edit-region': 'cancelEditRegion'
    },
    beforeFirstRender() {
        if (this.collection == null) {
            this.collection = new PJQ.collections.settings.Regions();
        }
        if (!this.options.isFetched) {
            this.collection.fetch({
                success: _.bind(function () {
                    this.options.isFetched = true;
                    this.render();

                    if (typeof this.options.onFetch === 'function') {
                        this.options.onFetch();
                    }
                }, this)
            });
        }
        else {
            this.render();
        }
    },
    beforeRender: function(){
        this.renderData = {
            options: this.options,
            collection: this.collection
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".region-table"),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Region'
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.regionContext != null && this.regionContext.id === row.id) {
                                return '<input type="text" class="form-control input-region-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Region"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.regionContext != null && this.regionContext.id === row.id) {
                            content = '<button type="button" class="btn btn-success btn-save-region wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-region wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.regionContext != null ? ' disabled ' : '';
                            content = '<button type="button" class="btn btn-info btn-edit-region wd-30p mr-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-region wd-30p"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
                    }, this),
                    "width": "160px"
                }
            ],
        })
    },
    addClicked: function () {
        let newRegion = new PJQ.models.settings.Region({
            name: "",
            regionDescription: "",
            sortOrder: this.collection.length + 1,
        });
        this.dataTable.addRow(newRegion);
        this.regionContext = newRegion;
        this.dataTable.refresh()
    },
    editRegion: function (e) {
        this.regionContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.dataTable.refresh();
    },
    deleteRegion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            region = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Region",
            body: "Are you sure you want to delete this region?",
            onDelete: _.bind(function () {
                region.destroy({
                    success: _.bind(function () {
                        // this.collection.remove(region);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    regionSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            region = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-region-name');
        region.set('name', $name.val());

        let isNameValid = _.size(region.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            region.save(null, {
                success: _.bind(function () {
                    this.regionContext = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    cancelEditRegion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.regionContext.get('name').length === 0){
            this.dataTable.removeRow(row);
        }        this.regionContext = null;
        this.dataTable.refresh();
    },
});
